<template>
  <div class="sections">
    <app-settings id="settings-section"></app-settings>
    <app-table
      id="computers-section"
      data-id="computers"
      v-bind:class="{ open: !clientUser && !app && !printer }"
    ></app-table>
    <app-table
      id="printers-section"
      data-id="printers"
      v-bind:class="{ open: clientUser || app || printer }"
    ></app-table>
    <app-table id="usage-section" data-id="usage"></app-table>
    <app-table id="services-section" data-id="services"></app-table>
    <app-table id="clients-section" data-id="clients"></app-table>
    <app-table id="groups-section" data-id="groups"></app-table>
    <app-table id="policies-section" data-id="policies"></app-table>
  </div>
</template>

<script>
import Settings from "./Settings.vue";
import Table from "./Table.vue";
import { mapState } from "vuex";
export default {
  components: {
    "app-settings": Settings,
    "app-table": Table
  },
  computed: {
    ...mapState({
      app: state => state.user.app,
      clientUser: state => state.user.clientUser,
      desktop: state => state.user.desktop,
      printer: state => state.user.printer
    })
  }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Sections.vue